import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';
import type {
  GetPortalAnsweringConfigResponse,
  JsonObject,
} from '@/app-package';

export type PortalAnsweringConfig =
  JsonObject<GetPortalAnsweringConfigResponse>;

/**
 * Gets the answering service configuration for a specific portal
 * @param portalId - The ID of the portal
 * @param orgId - The ID of the organization
 */
const getPortalAnsweringConfig = async (portalId: string, orgId: string) => {
  if (!portalId || !orgId) return;

  const config: AxiosRequestConfig = {
    url: `/answering_subscription/portal_config`,
    method: 'get',
    params: { id: portalId, orgId },
  };

  const { data } = await axios.request<PortalAnsweringConfig>(config);

  return data;
};

export default getPortalAnsweringConfig;
